import { Button, Tooltip } from "@mantine/core";

import { useCollapsable } from "../../Collapsable";

import type { ButtonProps } from "@mantine/core";
import type { FC, ReactNode } from "react";

export type CollapsableToggleButtonProps = {
  children?: ReactNode | ((opened: boolean) => ReactNode);
  tooltip?: string;
} & Omit<ButtonProps, "children" | "color" | "onClick" | "variant">;

export const CollapsableToggleButton: FC<CollapsableToggleButtonProps> = ({
  children,
  tooltip,
  ...props
}) => {
  const { opened, toggle } = useCollapsable();

  return (
    <Tooltip
      label={tooltip}
      disabled={tooltip === undefined}
      events={{ hover: true, focus: true, touch: true }}
    >
      <Button {...props} color="primary" onClick={toggle} variant="light">
        {typeof children === "function" ? children(opened) : children}
      </Button>
    </Tooltip>
  );
};
